import { http } from '@utils/index';

interface Props {}

const get = (props?: Props) => {
	return http.get<APIResponse<SaCourseTypesRes[]>>(`/sa/course-types`);
};
export default get;
